import NotificationConfiguration from '../../components/NotificationConfiguration'
import { Form } from '../../components/NotificationConfiguration/form/types'
import {
    loadNotificationPreferences,
    updateNotificationPreferences,
} from '@/features/settings/thunks/notificationPreferences'
import { NotificationSettings } from '@/features/settings/types'
import {
    mapFormValuesToSettings,
    mapSettingsToFormValues,
} from '@/features/settings/utils/notificationSettingsTransforms'
import { useAppDispatch, useAppSelector } from '@/hooks/redux'
import { authSelectors } from '@/redux/reducers/auth/selectors'
import { FC, useEffect, useState } from 'react'

const NotificationPage: FC = () => {
    const [prefs, setPrefs] = useState<NotificationSettings | null>(null)

    const dispatch = useAppDispatch()
    const consumerUuid = useAppSelector(authSelectors.deviceId)

    const handleFormSubmit = async (form: Form) => {
        if (!consumerUuid) return

        try {
            const updatedPreferences = mapFormValuesToSettings(form)
            const newPrefs = await dispatch(
                updateNotificationPreferences({ consumerUuid, prefs: updatedPreferences })
            ).unwrap()

            setPrefs(newPrefs)
        } catch {
            // error already logged inside the thunk
        }
    }

    useEffect(() => {
        if (!consumerUuid) return
        ;(async () => {
            try {
                const loadedPrefs = await dispatch(
                    loadNotificationPreferences(consumerUuid)
                ).unwrap()

                setPrefs(loadedPrefs)
            } catch {
                // error already logged inside the thunk
            }
        })()
    }, [consumerUuid, dispatch])

    if (!prefs) return null

    return (
        <NotificationConfiguration
            initialFormValues={mapSettingsToFormValues(prefs)}
            onFormSubmit={handleFormSubmit}
        />
    )
}

export default NotificationPage
